import { graphql } from '@/gql'

export const ApprovableContractFragment = graphql(`
  fragment ApprovableContractFragment on Contract {
    id
    jobName
    jobDescription
    rate
    rateType
    currency
    startDate
    endDate
    purchaseOrderNumber
    address
    locationPreference
    companyName
    companyLocation {
      formattedAddress
    }
  }
`)

export const HireApprovableFragment = graphql(/* GraphQL */ `
  fragment HireApprovableFragment on Hire {
    id

    latestContract {
      ...ApprovableContractFragment
    }

    activeContract {
      ...ApprovableContractFragment
    }

    job {
      id
      url
      currency
      internalBudget
      name
      market
      customFieldValues {
        id
        displayValue
        customField {
          title
          description
        }
      }
    }

    worker {
      id
      name
      initials
      avatar
      currency
      dayRate
      avatarPath @client
    }

    recruiter {
      id
      name
      owner {
        id
        name
      }
    }
    recruiterManagesWorkers
    recruiterOwnershipDays
    recruiterFee

    status

    company {
      id
      name
      hasMultipleBusinessEntities
    }

    classificationResult
    classificationLabel
    classificationPdfUrl
  }
`)

export const ApprovalStateFragment = graphql(/* GraphQL */ `
  fragment ApprovalStateFragment on ApprovalState {
    id
    state
    actionedBy {
      name
      email
      id
      avatar
    }
    message
    approver {
      id
      position
      userGroup {
        name
        id
        description
        users(first: 5, page: 1) {
          data {
            name
            email
            id
            avatar
          }
          paginatorInfo {
            total
            count
            hasMorePages
          }
        }
      }
    }
    createdAt
  }
`)

export const WorkflowDetailsFragment = graphql(`
  fragment WorkflowDetailsFragment on Approval {
    id
    name
    description
    status
    trigger
  }
`)
